import { MainBlock } from '@blocks/BlockMain/model'

import { PagesPath, pagesTitles } from './pages-titles'

export const mainBlock: MainBlock = {
	title: pagesTitles[PagesPath.poluchiteBezBankov].mainBlockTitle,
	textItems: [
		'Рефинансирование по честной ставке',
		'Быстрый ответ по заявке',
		'Без комиссии за выдачу',
	],
	buttonText: 'Оставить заявку',
	footnote: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
	faceImageName: {
		mobile: 'KV-loans-business-mob.png',
		default: 'keyvisual-loans-business.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}
